import { isNull } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import './PaymentMethod.scss';

const PaymentMethod = ({ calculatedPayment, cashdown, frequency, methodTitle, retail, term, displayCreditRate }) => {
    let blockContent;
    if (!isNull(frequency) && !isNull(calculatedPayment) && !isNull(term)) {
        blockContent = (
            <div className="selection-year-bloc__paymentMethod--values">
                <div className="price-highlight sr-text is-bold is-price">
                    {LocaleService.l(calculatedPayment, CurrencyFormats.CURRENCY_0)}
                    <span className="price-highlight__frequency">{frequency}</span>
                </div>
                <div className="terms-highlight">
                    <span className="terms-highlight__apr sr-text is-bold">
                        {!displayCreditRate || !term?.creditRate ? term.apr : term?.creditRate}%
                        {displayCreditRate && ' APR'}
                    </span>
                    {LocaleService.t('modelYearSection.TERMS', {
                        term: term.term,
                        month: LocaleService.t('TERMLABELS.MONTHS'),
                    })}
                </div>
                <div className="cashdown-highlight">
                    {LocaleService.t('modelYearSection.CASHDOWN', {
                        cashDown: LocaleService.l(cashdown, CurrencyFormats.CURRENCY_0),
                    })}
                </div>
            </div>
        );
    } else if (!isNull(retail)) {
        blockContent = (
            <div className="selection-year-bloc__paymentMethod--values">
                <span className="sr-text is-bold">{LocaleService.l(retail, CurrencyFormats.CURRENCY_0)}</span>
            </div>
        );
    } else {
        blockContent = <div className="not-available">{LocaleService.t('modelYearSection.notAvailable')}</div>;
    }
    return (
        <div className="selection-year-bloc__paymentMethod">
            <div className="selection-year-bloc__paymentMethod--title sr-text is-bold">
                {methodTitle}
                <span className="sr-text is-regular">{LocaleService.t('startingAt')}</span>
            </div>
            {blockContent}
        </div>
    );
};

PaymentMethod.defaultProps = {
    calculatedPayment: null,
    cashdown: null,
    frequency: null,
    retail: null,
    term: null,
    displayCreditRate: false,
};

PaymentMethod.propTypes = {
    calculatedPayment: PropTypes.number,
    cashdown: PropTypes.number,
    frequency: PropTypes.string,
    methodTitle: PropTypes.string.isRequired,
    retail: PropTypes.number,
    term: PropTypes.number,
    displayCreditRate: PropTypes.bool,
};

PaymentMethod.displayName = 'PaymentMethod';

export default PaymentMethod;
